import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, ButtonGroup, withAnimatedNavigationHeader, } from 'design-system';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { logDeleteDetails } from './analytics';
import SelectCompetitorApp from './components/SelectCompetitorAppScrollView';
import useNavigateAfterIssueStep from './hooks/useNavigateAfterIssueStep';
import { DeleteReasonID } from './reasons';
const strings = {
    [DeleteReasonID.UseAnotherApp]: { title: 'Which app are you using?' },
    [DeleteReasonID.BankDoesTheSame]: { title: 'Which bank are you using?' },
};
const DeleteSelectAppScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    const navigateAfterIssueStep = useNavigateAfterIssueStep();
    const onPress = useCallback((name) => {
        navigateAfterIssueStep();
        logDeleteDetails('delete', name || 'No other app', route.params.reason === DeleteReasonID.UseAnotherApp
            ? 'Apps'
            : 'Banks');
    }, [navigateAfterIssueStep, route.params.reason]);
    const onPressOther = useCallback(() => {
        navigation.navigateDeprecated('DeleteText', {
            reason: route.params.reason,
        });
    }, [route.params.reason]);
    const onPressBack = useCallback(() => {
        navigation.goBack();
    }, []);
    return (<View style={styles.container}>
        <SelectCompetitorApp title={strings[route.params.reason].title} onPressApp={onPress} onPressOther={onPressOther} scrollHandler={scrollHandler}/>
        <ButtonGroup type="floating" margins>
          <Button brandReversed title="Take me back" onPress={onPressBack}/>
        </ButtonGroup>
      </View>);
}, ({ route, colors }) => ({
    title: strings[route.params.reason].title,
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default DeleteSelectAppScreen;
